import React from 'react';
import { RunnerPageDescription } from '@Client/runner.directives/common/PageDescription';
import { CreationHubPicker } from './CreationHubPicker';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { getService } from '@Client/runner.hooks/useService';
import FlowModelType from '@Shared.Angular/@types/core/contracts/constants/flowModelType';
import { BrandColor } from '@Shared.Angular/@types/brandColor';

export const CreateWorkflowHubPage = () => {
  const $state = getService('$state');
  const appConfig = getService('APP_CONFIG');
  const goToWorkflowCreationState = (stateName: string) => {
    $state.go(stateName, { flowModelType: FlowModelType.Workflow });
  };

  const workflowAiGroup = appConfig.enableFlowModelGeneration
    ? {
        title: 'Build With AI',
        color: BrandColor.PrimaryBlue,
        label: 'AI',
        iconClass: 'fa-sparkles',
        items: [
          {
            iconClass: 'fa-file-lines',
            title: 'Generate from Text',
            description:
              'Enter text, or upload an MD or TXT file, and AI will generate a workflow with steps, approvals, decision paths and form fields.',
            color: BrandColor.PrimaryBlue,
            onClick: () => {
              goToWorkflowCreationState(
                STATE_MAPPINGS.creationHubWorkflowFromText
              );
            }
          },
          {
            iconClass: 'fa-image',
            title: 'Generate from Image',
            description:
              'Upload an image and AI will analyse the content to generate a workflow with steps, approvals, decision paths and form fields.',
            color: BrandColor.PrimaryBlue,
            onClick: () => {
              goToWorkflowCreationState(
                STATE_MAPPINGS.creationHubWorkflowFromImage
              );
            }
          },
          {
            iconClass: 'fa-table',
            title: 'Generate from CSV',
            description:
              'Upload a CSV and AI will analyse the data to generate a workflow with steps, approvals, decision paths and form fields.',
            color: BrandColor.PrimaryBlue,
            onClick: () => {
              goToWorkflowCreationState(
                STATE_MAPPINGS.creationHubWorkflowFromCsv
              );
            }
          },
          appConfig.enableVideoToXGeneration && {
            iconClass: 'fa-upload',
            title: 'Generate from Video',
            description:
              'Upload an existing video and AI will generate a workflow with steps, approvals, decision paths and form fields.',
            color: BrandColor.PrimaryBlue,
            onClick: () => {
              goToWorkflowCreationState(
                STATE_MAPPINGS.creationHubWorkflowFromVideo
              );
            }
          },
          appConfig.enableAudioToXGeneration && {
            iconClass: 'fa-file-audio',
            title: 'Generate from Audio',
            description:
              'Upload an existing audio file and AI will generate a workflow with steps, approvals, decision paths and form fields.',
            color: BrandColor.PrimaryBlue,
            onClick: () => {
              goToWorkflowCreationState(
                STATE_MAPPINGS.creationHubWorkflowFromAudio
              );
            }
          },
          appConfig.enableVideoRecording &&
            appConfig.enableVideoToXGeneration && {
              iconClass: 'fa-video',
              title: 'Record Your Screen with AI',
              description:
                'Record your screen and voice live with the desktop recorder, and AI will build the workflow with steps, approvals and decisions.',
              color: BrandColor.PrimaryBlue,
              onClick: () => {
                goToWorkflowCreationState(
                  STATE_MAPPINGS.creationHubWorkflowFromRecording
                );
              }
            }
        ]
      }
    : null;

  return (
    <div className="create-workflow-hub-page creation-hub-page">
      <RunnerPageDescription
        showText={false}
        backLinkText="Back"
        backLinkState={STATE_MAPPINGS.creationHub}
      />
      <CreationHubPicker
        title="New Workflow"
        description="Pick how you'd like to create your workflow."
        groups={[
          {
            title: 'Build Manually',
            color: BrandColor.Grey,
            label: 'No AI',
            items: [
              {
                iconClass: 'fa-pen-line',
                title: 'Build from Scratch',
                description:
                  'Build a workflow from scratch using the drag-and-drop builder, with full control to customise every step.',
                color: BrandColor.Grey,
                onClick: () => {
                  goToWorkflowCreationState(
                    STATE_MAPPINGS.creationHubWorkflowFromScratch
                  );
                }
              }
            ]
          },
          ...(workflowAiGroup ? [workflowAiGroup] : [])
        ]}
      />
    </div>
  );
};
